import type { AppModule } from '@ohmybible/core';

import * as routes from './routes';

/** The Privacy Policy and the Terms of Use: public pages, linked from sign-in. */
export const LegalModule: AppModule = {
  routes,
};
